class SearchDrawer extends HTMLElement {
  constructor() {
    super();
    this.toggleButton = null;
    this.backdrop = null;
    this.input = this.querySelector("input");
    this.searchResultsContainer = this.querySelector("#search-results");
  }

  connectedCallback() {
    this.toggleButton = document.getElementById("toggle-search");
    this.backdrop = document.querySelector("[data-backdrop]");
    if (this.toggleButton) {
      this.toggleButton.addEventListener("click", this.openDrawer.bind(this));
    } else {
      console.error("No element with ID 'toggle-search' found");
    }
    if (this.backdrop) {
      this.backdrop.addEventListener("click", this.closeDrawer.bind(this));
    } else {
      console.error("No element with attribute 'data-backdrop' found");
    }
    this.input.addEventListener("input", this.handleInput.bind(this));
  }

  openDrawer() {
    freezeBody(true);
    this.backdrop.setAttribute("data-active", "");
    this.setAttribute("data-active", "");
    this.input.focus();
  }

  closeDrawer() {
    freezeBody(false);
    this.backdrop.removeAttribute("data-active");
    this.removeAttribute("data-active");
    setTimeout(() => {
      this.input.value = "";
      this.searchResultsContainer.innerHTML = "";
    }, 300);
  }

  handleInput = debounce(async (event) => {
    if (!event.target.value) {
      this.searchResultsContainer.innerHTML = "";
      return;
    }
    const results = await fetch(
      `${window.Shopify.routes.root}search/suggest?q=${event.target.value}&section_id=predictive-search`,
    );
    const doc = await results.text();
    const parser = new DOMParser();
    const parsed = parser.parseFromString(doc, "text/html");
    this.searchResultsContainer.innerHTML = parsed.body.innerHTML;
  }, 300);
}

customElements.define("search-drawer", SearchDrawer);
